// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".programManagement .setColorOrange {\n  color: orange;\n}\n.programManagement .setColorBlue {\n  color: #1F75D5;\n}\n.programManagement .setColorGray {\n  color: #97a8be;\n}\n.programManagement .banClick {\n  opacity: 0.5;\n}\n", ""]);
// Exports
module.exports = exports;
